import {observer} from "mobx-react-lite"
import React, {useEffect, useState} from "react"
import {Link, match, Route, useHistory} from "react-router-dom"

import {appPages} from "../../App";

import {Field, SkeletonBox, WaCheckbox} from "../../lib/wa-2.0"

import controller from "./PricesHistoryController"
import ReactPaginate from "react-paginate"
// import controller from "../../store/pageControllers/PriceUpdateController"


const PricesHistoryComponent = observer(() => {


    useEffect(() => {
        controller.loadPrices()
    }, [])

    const history = useHistory();
    const handleRowClick = (id: string) => {
        history.push(appPages.priceSync + '/history/product/' + id);
        // controller.productId = +id
    }

    return <div>
        <h1>История обновлений</h1>
        {!controller.notExport && (controller.totalCount > -1) && <div className={"align-right custom-my-8"}>
            <input
                className={"ozon_left"}
                type={"text"}
                value={controller.search_query}
                onChange={(e) => {
                    controller.search_query = e.target.value
                }}/>


                <WaCheckbox
                    id={'not_found'}
                    checked={controller.not_found}
                    onChange={(e) => controller.not_found = e.target.checked}
                />
                <label htmlFor={'not_found'}>Ненайденные товары</label>


        </div>}
        {controller.pricesLoaded ? <table>
            <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>product_id </th>
                    <th>offer_id</th>
                    <th>Наименование товара</th>
                </tr>
            </thead>
            <tbody>
            {controller.prices.map((item, index) =>
                <tr key={index} onClick={()=>handleRowClick(item.product_id)}  style={{cursor:'pointer'}}>
                    <td>{item.product_id}</td>
                    <td>{item.offer_id}</td>
                    <td>{item.product_name}</td>
                </tr>
            )}
            </tbody>
        </table> : controller.notExport ? <div>Обновления цен еще не было</div> : <p>Не найдено</p>}
        {controller.countOfPages > 1 &&
        <div className={'paginate-compare'}>
            <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={controller.countOfPages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={controller.page}
                onPageChange={({selected}) => {
                    controller.loadPrices(selected)
                }
                }
            />
        </div>}
    </div>
})

export default PricesHistoryComponent